import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-active-icon',
  templateUrl: './active-icon.component.html',
  styleUrls: ['./active-icon.component.scss']
})
export class ActiveIconComponent implements OnInit {
  @Input() active: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

}
